<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{$t('keywords.register') }}</v-toolbar-title>
            <v-row>
              <v-col cols="12" sm="3">
                <v-select
                  v-if="showSelect && !isUpdating"
                  :items="collections"
                  v-model="objEditar.collection"
                  :rules="requiredRules(objEditar.collection)"
                  :label="$t('fromto.list')"
                  :hint="$t('fromto.bundler')"
                >
                  <v-icon @click="showSelect = !showSelect" color="primary" slot="append">mdi-plus</v-icon>
                </v-select>
                <v-text-field
                  v-else
                  :readonly="isUpdating"
                  :rules="requiredRules(objEditar.collection)"
                  name="collection"
                  :label="$t('fromto.list')"
                  :hint="$t('fromto.bundler')"
                  v-model="objEditar.collection"
                />
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field
                  name="from"
                  :label="$t('fromto.from')"
                  v-model="objEditar.from"
                  :readonly="isUpdating"
                  :rules="requiredRules(objEditar.from)"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field name="to" :label="$t('fromto.to')" v-model="objEditar.to" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
        <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/FromToService'
import LocalStorageService from '../../services/LocalStorageService'
import { requiredRules } from '../../utils/rules'

export default {
  name: 'fromToForm',

  props: {
    collection: String,
    from: String
  },

  data: () => ({
    requiredRules,
    showSelect: true,
    objEditar: {
      collection: '',
      from: '',
      to: '',
      type: '',
      clientPrefix: ''
    },
    collections: [],
    isUpdating: false
  }),

  mounted () {
    this.loadDB()
    this.loadAllCollections()
  },

  methods: {
    loadAllCollections () {
      Servico.findAllCollections()
        .then(response => { this.collections = response?.data ?? [] })
        .catch(() => { this.collections = [] })
    },

    loadDB () {
      if (this.collection && this.from) {
        Servico.findById(this.collection, this.from)
          .then(response => {
            this.isUpdating = true
            this.objEditar = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },

    saveItem () {
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()
      if (this.$refs.form.validate()) {
        if (this.isUpdating) this.updateItem()
        else this.createItem()
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },

    createItem () {
      Servico.insert(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    updateItem () {
      Servico.update(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }
  }
}
</script>
